import { createApp } from 'vue'
import App from './App.vue'
import { MotionPlugin } from '@vueuse/motion'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './assets/global.css'
import { startAnimatedFavicon } from './animatedFavicon'

const app = createApp(App)
app.use(MotionPlugin)
app.mount('#app')

AOS.init()
startAnimatedFavicon()
